<script>

import _ from 'lodash'
import quillConfig from '@/quill/config'
import InputField from '@/components/Page/Sections/Partials/InputField'

export default {
    name: 'FormInputField',
    extends: InputField,
    data() {
        // TODO
        // internal links must be absolute
        // quillConfig.modules.link.pages = this.getPageOptions
        let config = _.cloneDeep(quillConfig)
        config.modules.link.pages = []
        config.modules.link.types = ['external', 'email', 'phone']
        return {
            quillConfig: config,
            visibleBlockSettings: false,
            // tags: []
        }
    },
    beforeCreate() {
        this.$options.components.InputField = InputField
    },
}
</script>
